import {GetRefundPlansParams} from 'domain/usecases';
import {makeGetRefundPlans} from 'main/factories/usecases';

export const getRefundPlans = async (params: GetRefundPlansParams) => {
	const data = await makeGetRefundPlans().get(params);

	if (!data) {
		return {
			content: {
				history: [],
				total: 0,
				totalPerPage: 0,
			},
			notifications: [],
		};
	}

	return data;
};
